import { Box, Collapse, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { GetReporteAperturaLinea } from "../../../hooks/aperturaLinea";
import { useLoading } from "../../../components/Loading/useLoading";
import React, { useContext, useEffect, useState } from "react";
import { AperturaLineaFiltro } from "./AperturaLineaFiltro";
import { ThemeContext } from "@emotion/react";
import { useDispatch } from "react-redux";

export const ReporteAperturaLineaIndex = () => {

  const dispatch = useDispatch();
  const { setAppLoading } = useLoading();
  const theme = useContext(ThemeContext);
  const { getReporteAperturaLineaMutation } = GetReporteAperturaLinea();
  const [movPros, setMovPros] = useState([]);

  useEffect(() => {
    dispatch(
      HEADER_DATA_UPDATE({ nombreData: null })
    )
  }, []);

  const get_movimientos = (almacen, startDate, endDate) => {
    setAppLoading(true)
    getReporteAperturaLineaMutation({ almacen, startDate, endDate }, {
      onSuccess: (data) => {
        console.log(data)
        setMovPros(data)
      },
      onError: (error) => {
        console.log(error)
      },
      onSettled: () => {
        setAppLoading(false)
      }
    })
  }

  function SecondRow(props) {
    const { row } = props;

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.pregunta}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.respuesta}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    const open_subtabla = () => {
      if (open) {
        setOpen(!open);
      } else {
        setOpen(!open);
      }
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 0.5 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ width: 25 }}
              onClick={() => open_subtabla()}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.fecha}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.horario}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.respuestas[0]?.usuario}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Check de Linea
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Pregunta
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Respuesta
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.respuestas?.map((secRow, index) => (
                      <SecondRow key={index} row={secRow} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Grid container spacing={0} sx={{ height: '87vh', alignContent: 'flex-start', overflowY: 'auto' }}>
      <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start' }} className="center_item">
        <AperturaLineaFiltro key='filtros_r_turno' get_data={get_movimientos} canDownXlsx={movPros.length > 0} />
      </Grid>
      <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }} className="center_item">
        {
          movPros.length > 0 &&
          <Paper
            style={{ maxHeight: '100vh', overflowY: "scroll", width: "100%" }}
            sx={{ boxShadow: "none" }}
          >
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead
                  sx={{
                    display: "table-head",
                    backgroundColor: theme.palette.primary.main,
                    fontWeight: 600,
                  }}
                >
                  <TableRow>
                    <TableCell align="center" sx={{ color: "white" }} />
                    <TableCell align="center" sx={{ color: "white" }}>
                      Fecha
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Turno
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Usuario Responsable
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {movPros?.map((row, index) => (
                    <Row key={index} row={row} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        }
      </Grid>
    </Grid>
  )
}